"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var yup = __importStar(require("yup"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var classnames_1 = __importDefault(require("classnames"));
var FinalStepForm = function (_a) {
    var onBack = _a.onBack, authInputMode = _a.authInputMode, _b = _a.withTitle, withTitle = _b === void 0 ? true : _b, _c = _a.initialValues, initialValues = _c === void 0 ? {} : _c;
    var router = (0, navigation_1.useRouter)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var config = (0, swr_hooks_1.useConfig)();
    var lang = (0, next_intl_1.useLocale)();
    var params = (0, navigation_1.useSearchParams)();
    var code = params.get('code') || undefined;
    var backUrl = params.get('back');
    var openModal = (0, apps_shared_1.useOpenModal)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var _d = (0, swr_hooks_1.useSignUp)({
        successAction: function () {
            if (backUrl)
                router.push(backUrl);
            else {
                if (config === null || config === void 0 ? void 0 : config.signUpOpenDepositAfterRegistration) {
                    openDeposit();
                }
                else if ((config === null || config === void 0 ? void 0 : config.signUpCongratsEnabled) !== false) {
                    openModal(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL_CONGRATS);
                }
            }
            if ((config === null || config === void 0 ? void 0 : config.version) &&
                (config === null || config === void 0 ? void 0 : config.version) === 'licensed' &&
                typeof window !== 'undefined' &&
                (config === null || config === void 0 ? void 0 : config.redirectRouter))
                return (window.location.href = config.redirectRouter);
        },
    }), signUp = _d.signUp, isSubmitting = _d.isSubmitting, error = _d.error;
    var normalizedInitialValues = (0, react_1.useMemo)(function () {
        var safeInitialValues = initialValues || {};
        return Object.entries(safeInitialValues).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value === undefined)
                return acc;
            if (key === 'dateOfBirth' && typeof value === 'string')
                acc[key] = new Date(value);
            else
                acc[key] = value;
            return acc;
        }, {});
    }, [initialValues]);
    var validateSchema = (0, react_1.useMemo)(function () {
        return yup.object({
            firstName: yup.string().required(tErr('firstNameIsRequired')),
            lastName: yup.string().required(tErr('lastNameIsRequired')),
            city: yup.string().required(tErr('customer.city.isRequired')),
            postalCode: yup.string().required(tErr('customer.zip.isRequired')),
            address: yup.string().required(tErr('customer.address.isRequired')),
            dateOfBirth: yup.string().required(tErr('dateOfBirthIsRequired')),
        });
    }, [tErr]);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var affiliateData = Lockr.get('affiliate');
        var inviteData = Lockr.get('invite');
        var newDate = (affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.date)
            ? (0, date_fns_1.addDays)(new Date(affiliateData.date), 7)
            : new Date();
        var isExpiredAffDate = (0, date_fns_1.isAfter)(new Date(), newDate);
        var country = ((_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.country) === null || _a === void 0 ? void 0 : _a.value) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.country) || undefined;
        var currency = ((_b = initialValues === null || initialValues === void 0 ? void 0 : initialValues.currency) === null || _b === void 0 ? void 0 : _b.value) || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.currency) || undefined;
        var promo = (initialValues === null || initialValues === void 0 ? void 0 : initialValues.promocode) ||
            (initialValues === null || initialValues === void 0 ? void 0 : initialValues.promo) ||
            (initialValues === null || initialValues === void 0 ? void 0 : initialValues.promoCode);
        var dateOfBirthFormatted = (values === null || values === void 0 ? void 0 : values.dateOfBirth)
            ? (0, date_fns_1.format)(new Date(values.dateOfBirth), 'yyyy-MM-dd')
            : undefined;
        var payload = {
            email: initialValues === null || initialValues === void 0 ? void 0 : initialValues.email,
            password: initialValues === null || initialValues === void 0 ? void 0 : initialValues.password,
            currency: currency,
            country: country,
            nickname: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.nickname) ? initialValues === null || initialValues === void 0 ? void 0 : initialValues.nickname : undefined,
            receivePromos: true,
            partnerId: !isExpiredAffDate && ((_c = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _c === void 0 ? void 0 : _c.partnerId)
                ? Number((_d = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _d === void 0 ? void 0 : _d.partnerId)
                : undefined,
            offerId: !isExpiredAffDate && ((_e = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _e === void 0 ? void 0 : _e.offerId)
                ? Number((_f = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _f === void 0 ? void 0 : _f.offerId)
                : undefined,
            clickId: !isExpiredAffDate && ((_g = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _g === void 0 ? void 0 : _g.clickId)
                ? String((_h = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _h === void 0 ? void 0 : _h.clickId)
                : undefined,
            partnerType: !isExpiredAffDate && ((_j = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _j === void 0 ? void 0 : _j.type)
                ? String((_k = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _k === void 0 ? void 0 : _k.type)
                : undefined,
            referralCode: (inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                ? String(inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                : undefined,
            language: lang ? lang : undefined,
            code: code,
            promocode: promo ? promo : undefined,
            firstName: values.firstName,
            lastName: values.lastName,
            city: values.city,
            postalCode: values.postalCode,
            address: values.address,
            phone: values.phone,
            dateOfBirth: dateOfBirthFormatted,
        };
        signUp(payload);
    }, [initialValues, code, lang, signUp]);
    var errorToShow = (0, react_1.useMemo)(function () {
        if (!error)
            return null;
        if (typeof error === 'string')
            return tErr(error);
        return tErr('not_authorized');
    }, [error, tErr]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        withTitle ? react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('finalStep')) : null,
        react_1.default.createElement(react_final_form_1.Form, { keepDirtyOnReinitialize: true, onSubmit: onSubmitHandler, initialValues: normalizedInitialValues, validate: (0, apps_shared_1.formValidator)(validateSchema), render: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting, form = _a.form;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit, autoComplete: "off" },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.fieldsGrid) },
                        react_1.default.createElement(react_final_form_1.Field, { name: "firstName", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('inputFirstName'), labelText: t('firstName'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } }),
                        react_1.default.createElement(react_final_form_1.Field, { name: "lastName", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('inputLastName'), labelText: t('lastName'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } })),
                    react_1.default.createElement(react_final_form_1.Field, { name: "city", render: function (_a) {
                            var input = _a.input, meta = _a.meta;
                            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('inputCity'), labelText: t('city'), hasError: meta.error && meta.touched })),
                                meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                        } }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldsGrid },
                        react_1.default.createElement(react_final_form_1.Field, { name: "postalCode", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('inputPostalCode'), labelText: t('postalCode'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } }),
                        react_1.default.createElement(react_final_form_1.Field, { name: "dateOfBirth", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.DatePicker, __assign({}, input, { mode: authInputMode, labelText: t('dateOfBirth'), helperButton: meta.error && meta.touched && { type: 'error' } })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } })),
                    react_1.default.createElement(react_final_form_1.Field, { name: "address", render: function (_a) {
                            var input = _a.input, meta = _a.meta;
                            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('inputAddress'), labelText: t('address'), hasError: meta.error && meta.touched })),
                                meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                        } }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.mainErrorWrapper }, errorToShow && react_1.default.createElement(ui_components_1.ErrorText, null, errorToShow)),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
                        react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", loading: isSubmitting || submitting, text: "upper", maxWidth: "100%", width: "100%" }, t('complete')),
                        react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.backButton, onClick: function () { return onBack(form.getState().values); } }, t('previousStep')))));
            } })));
};
exports.default = FinalStepForm;
